import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-24 px-6 md:px-16 rounded-b-2xl overflow-hidden relative"
      style={{ backgroundColor: "#0073E5" }}
    >
      {/* Decorative blobs */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-[-20%] right-[-10%] w-[400px] h-[400px] rounded-full opacity-20"
          style={{ backgroundColor: "#D4F419", filter: "blur(80px)" }}
        />
        <div
          className="absolute bottom-[-10%] left-[-5%] w-[350px] h-[350px] rounded-full opacity-15"
          style={{ backgroundColor: "#E4D6EA", filter: "blur(80px)" }}
        />
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-8">
          Let&apos;s build<br />something great.
        </h2>
        <p className="text-base md:text-lg text-white/70 max-w-lg mx-auto mb-10 leading-relaxed">
          Have a product idea, a process to automate, or a market to crack? We&apos;re the team that turns vision into working software — and then helps you grow it. From first line of code to your first thousand users.
        </p>
        <Link
          to="/contact-us"
          className="inline-flex items-center gap-2 font-semibold px-8 py-4 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap text-black"
          style={{ backgroundColor: "#D4F419" }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#c2e010")}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#D4F419")}
        >
          Start a project
          <i className="ri-arrow-right-line"></i>
        </Link>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm font-medium text-white/70">
          <div className="flex items-center justify-center gap-2">
            <i className="ri-code-s-slash-line text-lg" style={{ color: "#D4F419" }}></i>
            Full-cycle software development
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="ri-user-line text-lg" style={{ color: "#D4F419" }}></i>
            Dedicated project manager
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="ri-rocket-line text-lg" style={{ color: "#D4F419" }}></i>
            Marketing &amp; growth support
          </div>
        </div>
      </div>
    </section>
  );
}
